import React from "react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { money } from "@/lib/api";

const LABELS = { 30: "Reserva tu cupo", 50: "Mitad ahora", 100: "Pago completo" };

export default function PercentSelector({ options = [30, 50, 100], value, onChange, total }) {
  return (
    <RadioGroup value={String(value)} onValueChange={(v) => onChange(Number(v))} className="grid grid-cols-3 gap-2" data-testid="percent-selector">
      {options.map((p) => {
        const active = Number(value) === p;
        return (
          <label key={p} htmlFor={`pct-${p}`} data-testid={`percent-option-${p}`}
            className={`relative cursor-pointer rounded-lg border-2 p-3 text-center transition-[border-color,background-color] duration-200 ${active ? "border-[var(--brand)] bg-[var(--brand)]/5" : "border-gray-200 hover:border-gray-300"}`}>
            <RadioGroupItem id={`pct-${p}`} value={String(p)} className="sr-only" />
            <div className={`text-xl font-bold ${active ? "brand-text" : "text-gray-800"}`}>{p}%</div>
            <div className="text-[11px] text-gray-500 leading-tight mt-0.5">{LABELS[p] || "Abono"}</div>
            {total > 0 && <div className="text-xs font-semibold text-gray-700 mt-1">{money((total * p) / 100)}</div>}
          </label>
        );
      })}
    </RadioGroup>
  );
}
